// =========================================================
// SMARTASAURUS - GLOBAL FEATURE FLAGS
// =========================================================
// Single source of truth controlling every launch-gated feature.
// Build is complete; commerce stays dormant until these flip.
//
// To launch commercially:
//   1. Register the company, bank, Stripe, taxes.
//   2. Flip PUBLIC_BETA_MODE -> false and the commerce flags below.
//   3. Redeploy. No code changes required.
// =========================================================

// --- Master switches -------------------------------------
export const PUBLIC_BETA_MODE = false;         // v1.0 shipped - beta banner off, commerce still gated by flags below
export const EARLY_ACCESS_MODE = false;         // v1.0 shipped - early access notices off

// --- Commerce ---------------------------------------------
export const SHOP_ENABLED = false;              // Show shop catalog as purchasable
export const CHECKOUT_ENABLED = false;          // Mount Stripe checkout UI
export const PAYMENTS_ENABLED = false;          // Server functions accept payment intents
export const STRIPE_ENABLED = false;            // Reserved: hard cutoff for Stripe calls
export const DOWNLOADS_ENABLED = false;         // Allow signed download URLs for paid grants
export const ORDER_HISTORY_ENABLED = false;     // Customer order history tab
export const CUSTOMER_PORTAL_ENABLED = false;   // Stripe customer portal entry
export const COUPONS_ENABLED = false;           // Apply coupon codes at checkout
export const WISHLIST_ENABLED = false;          // Public wishlist surfaces
export const INVOICES_ENABLED = false;          // Invoice generation + history

// --- Growth -----------------------------------------------
export const AFFILIATE_ENABLED = false;         // Affiliate dashboards & code capture
export const PROMOTIONS_ENABLED = false;        // Promotional banners / sale prices
export const NEWSLETTER_POPUPS_ENABLED = false; // Newsletter is not the primary capture surface - Broadcast is
export const BROADCAST_CHANNEL_URL = "https://www.instagram.com/channel/Abb0uo2Ci9GzCQmM/";
export const BROADCAST_CHANNEL_LABEL = "Join the Broadcast Channel";
export const ABANDONED_CART_ENABLED = false;    // Cart recovery emails
export const RECOMMENDATIONS_ENABLED = true;    // Discovery/article recommendations

// --- Experiments (Chunk 3 - reversible) -------------------
// Single-hero homepage: one emotional hook, one CTA, weekly-picked winner
// (highest-engagement discovery from the last 30 days).
// Flip to false to instantly roll back to the multi-slide carousel.
export const HOMEPAGE_HERO_V2 = true;



// --- Platform ---------------------------------------------
export const AI_ASSISTANT_ENABLED = false;      // Jotform AI agent embed
export const EMAIL_FUNCTIONAL = true;           // Outbound email is operational

// --- Helpers ----------------------------------------------
export const isCommerceLive = () =>
  !PUBLIC_BETA_MODE && SHOP_ENABLED && CHECKOUT_ENABLED && PAYMENTS_ENABLED;
